"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchoredIdentifierRegexp = exports.anchoredDigestRegexp = exports.anchoredNameRegexp = exports.referenceRegexp = void 0;
const expression = (...regexps) => new RegExp(regexps
    .map(re => re.source)
    .join(''));
const group = (...regexps) => new RegExp(`(?:${expression(...regexps).source})`);
const optional = (...regexps) => new RegExp(`${group(...regexps).source}?`);
const repeated = (...regexps) => new RegExp(`${group(...regexps).source}+`);
const anchored = (...regexps) => new RegExp(`^${expression(...regexps).source}$`);
const capture = (...regexps) => new RegExp(`(${expression(...regexps).source})`);
const alphaNumericRegexp = /[a-z0-9]+/;
const separatorRegexp = /(?:[._]|__|[-]*)/;
const nameComponentRegexp = expression(alphaNumericRegexp, optional(repeated(separatorRegexp, alphaNumericRegexp)));
const domainComponentRegexp = /(?:[a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])/;
const domainRegexp = expression(domainComponentRegexp, optional(repeated(/\./, domainComponentRegexp)), optional(/:/, /[0-9]+/));
const tagRegexp = /[\w][\w.-]{0,127}/;
const digestRegexp = /[a-zA-Z][a-zA-Z0-9]*(?:[-_+.][a-zA-Z][a-zA-Z0-9]*)*[:][a-fA-F0-9]{32,}/;
const anchoredDigestRegexp = anchored(digestRegexp);
exports.anchoredDigestRegexp = anchoredDigestRegexp;
const nameRegexp = expression(optional(domainRegexp, /\//), nameComponentRegexp, optional(repeated(/\//, nameComponentRegexp)));
const anchoredNameRegexp = anchored(optional(capture(domainRegexp), /\//), capture(nameComponentRegexp, optional(repeated(/\//, nameComponentRegexp))));
exports.anchoredNameRegexp = anchoredNameRegexp;
const referenceRegexp = anchored(capture(nameRegexp), optional(/:/, capture(tagRegexp)), optional(/@/, capture(digestRegexp)));
exports.referenceRegexp = referenceRegexp;
const identifierRegexp = /[a-f0-9]{64}/;
const anchoredIdentifierRegexp = anchored(identifierRegexp);
exports.anchoredIdentifierRegexp = anchoredIdentifierRegexp;
//# sourceMappingURL=regexp.js.map